"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailBuyBox = void 0;
const react_1 = __importStar(require("react"));
const add_to_cart_1 = require("../add-to-cart");
const mshop_add_to_cart_1 = require("../add-to-cart/mshop-add-to-cart");
const canvas_box_1 = require("../canvas-box");
const quantity_1 = require("../quantity");
const retail_buy_button_1 = require("../retail-buy-button");
const styles_1 = require("./styles");
const RetailBuyBox = (_a) => {
    var { width = '300px', padding = '14px 18px', justify = 'center', direction = 'row', minWidth = '250px', hideBorders = false, isMobileView = false, isMshopView = false } = _a, props = __rest(_a, ["width", "padding", "justify", "direction", "minWidth", "hideBorders", "isMobileView", "isMshopView"]);
    const [quantity, setQuantity] = (0, react_1.useState)(props.minOrderQuantity);
    return (react_1.default.createElement(styles_1.RetailBuyBoxContainer, Object.assign({ width: width, minWidth: minWidth, padding: padding, justify: justify, direction: direction, hideBorders: hideBorders }, props),
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.QuantityWrapper, null, props && react_1.default.createElement(quantity_1.Quantity, Object.assign({}, props, { setQuantity: setQuantity }))),
            react_1.default.createElement(canvas_box_1.CanvasContainer, { direction: isMobileView ? 'column' : 'row', wrap: 'nowrap' },
                props.callToActionCart && (react_1.default.createElement(styles_1.ButtonContainer, null, isMshopView ? (react_1.default.createElement(mshop_add_to_cart_1.MshopAddToCart, Object.assign({}, props, { quantity: quantity }))) : (react_1.default.createElement(add_to_cart_1.AddToCartButton, Object.assign({}, props, { quantity: quantity }))))),
                props.callToActionCheckout && (react_1.default.createElement(styles_1.RetailBuyButtonWrapper, { isMobileView: isMobileView },
                    react_1.default.createElement(retail_buy_button_1.RetailBuyButton, Object.assign({}, props, { quantity: quantity }))))))));
};
exports.RetailBuyBox = RetailBuyBox;
__exportStar(require("./types"), exports);
